import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2 sm:gap-8" }
const _hoisted_2 = { class: "flex flex-row items-center gap-2 sm:gap-4" }
const _hoisted_3 = { class: "flex flex-col items-start w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-sm pb-2 sm:pb-0" }, "Cuenta de accionista", -1)
const _hoisted_5 = { class: "flex flex-col sm:flex-row gap-4 w-full sm:items-center" }
const _hoisted_6 = { class: "flex flex-col sm:flex-row sm:items-center gap-4 py-3 sm:justify-start" }
const _hoisted_7 = { class: "flex flex-col sm:flex-row w-full justify-between sm:justify-start sm:items-center gap-4" }
const _hoisted_8 = { class: "flex flex-row items-center" }
const _hoisted_9 = ["checked"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "huey_izq",
  class: "mx-4 text-[12px]"
}, "Acumulado", -1)
const _hoisted_11 = { class: "flex flex-row items-center justify-between sm:justify-start" }
const _hoisted_12 = { class: "flex flex-row items-center w-full" }
const _hoisted_13 = ["checked"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "dewey_izq",
  class: "mx-4 text-[12px]"
}, "Filtrar por año", -1)
const _hoisted_15 = { class: "flex sm:hidden items-center h-8 sm:w-48" }
const _hoisted_16 = { class: "hidden sm:flex items-center h-8 sm:w-48" }
const _hoisted_17 = { class: "grid grid-cols-2 gap-5 h-full" }

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { storeToRefs } from "pinia";

import { FilterType } from "@/services/charts/types";

import { accountStore } from "@/stores/account";
import { shareMovementStore } from "@/stores/movements";

import SimpleSelector from "@/components/atoms/SimpleSelector.vue";
import ChartSection from "@/components/organisms/ChartSection.vue";
import ActionsChartSection from "@/components/organisms/ActionsChartSection.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MyStocksView',
  setup(__props) {

const router = useRouter();

const selectedYear = ref<number>(new Date().getFullYear());
const filterTypeSelected = ref<FilterType>(FilterType.ByConsolidated);

const movementsStore = shareMovementStore();

const accountStr = accountStore();
const { account: accountArray, activeAccount } = storeToRefs(accountStr);

const accounts = computed(() =>
  accountArray?.value?.data?.map((item) => {
    return {
      value: item.id,
      label: item.businessName
        ? item.businessName
        : item.firstName + "  " + item.lastName,
    };
  })
);

const setAccount = async (id: number) => {
  accountStr.setActiveAccount(id);
  movementsStore.query();
  router.push({ name: "MyStocks" });
};

return (_ctx: any,_cache: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("article", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("fieldset", _hoisted_5, [
          _createVNode(SimpleSelector, {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = 
              (e) => {
                setAccount(e?.target?.value);
              }
            ),
            selected: _unref(activeAccount),
            items: _unref(accounts) ?? [],
            horizontal: ""
          }, null, 8, ["selected", "items"]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("input", {
                  type: "radio",
                  id: "huey_izq",
                  name: "drone_izq",
                  value: "huey",
                  checked: filterTypeSelected.value == _unref(FilterType).ByConsolidated,
                  onChange: _cache[1] || (_cache[1] = 
                    async () => {
                      filterTypeSelected.value = _unref(FilterType).ByConsolidated;
                    }
                  )
                }, null, 40, _hoisted_9),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("input", {
                    type: "radio",
                    id: "dewey_izq",
                    name: "drone_izq",
                    checked: filterTypeSelected.value == _unref(FilterType).ByYear,
                    onChange: _cache[2] || (_cache[2] = 
                      async () => {
                        filterTypeSelected.value = _unref(FilterType).ByYear;
                      }
                    ),
                    value: "dewey"
                  }, null, 40, _hoisted_13),
                  _hoisted_14
                ]),
                _createElementVNode("div", _hoisted_15, [
                  (filterTypeSelected.value == _unref(FilterType).ByYear)
                    ? (_openBlock(), _createBlock(_component_Datepicker, {
                        key: 0,
                        modelValue: selectedYear.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedYear).value = $event)),
                        "year-picker": "",
                        "enable-time-picker": false,
                        cancelText: 'Cancelar',
                        selectText: 'Seleccionar'
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              (filterTypeSelected.value == _unref(FilterType).ByYear)
                ? (_openBlock(), _createBlock(_component_Datepicker, {
                    key: 0,
                    modelValue: selectedYear.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedYear).value = $event)),
                    "year-picker": "",
                    "enable-time-picker": false,
                    cancelText: 'Cancelar',
                    selectText: 'Seleccionar'
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_17, [
      _createVNode(ChartSection, {
        "selected-yr": selectedYear.value,
        "filter-type": filterTypeSelected.value,
        "active-acc": +_unref(activeAccount),
        class: "lg:col-span-1 col-span-2"
      }, null, 8, ["selected-yr", "filter-type", "active-acc"]),
      _createVNode(ActionsChartSection, {
        "selected-yr": selectedYear.value,
        "active-acc": +_unref(activeAccount),
        "filter-type": filterTypeSelected.value,
        class: "lg:col-span-1 col-span-2"
      }, null, 8, ["selected-yr", "active-acc", "filter-type"])
    ])
  ]))
}
}

})